import React, { useEffect, useState } from "react";

import FullWidthModal from "components/FullWidthModal";
import InstallPwa from "./InstallPwa";
import { oidcUserManager } from "config/authentication";
import { setTokenFromSessionStorage } from "config/http";
import useIsMobileView from "hooks/useIsMobileView";
import { useNavigate } from "react-router-dom";
import { ROUTE_PATHS } from "routes/paths";

function AuthenticationCallBack() {
  const navigate = useNavigate();
  const isPwa = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;

  const [showInstructions, setShowInstructions] = useState(false);
  const isMobileView = useIsMobileView();

  const handleUserRedirect = () => {
    oidcUserManager
      .signinRedirectCallback()
      .then(() => {
        setTokenFromSessionStorage();
      })
      .finally(() => {
        navigate(ROUTE_PATHS.market);
      });
  };

  useEffect(() => {
    if (isPwa || !isMobileView) {
      handleUserRedirect();
    } else {
      setShowInstructions(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPwa]);

  return (
    <FullWidthModal
      dir="rtl"
      title="به ساناکش خوش آمدید"
      maxWidth="xs"
      open={showInstructions}
      onClose={handleUserRedirect}
    >
      <InstallPwa hideShadow onClick={handleUserRedirect} />
    </FullWidthModal>
  );
}

export default AuthenticationCallBack;
